import { render, staticRenderFns } from "./milestone.vue?vue&type=template&id=580880f3&"
import script from "./milestone.vue?vue&type=script&lang=js&"
export * from "./milestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports